module.exports = __webpack_public_path__ + "static/media/sr.64fb37b4.svg";